<template>
  <div>
    <div class="text-h6">
      {{ title }}
    </div>
    <div
      v-if="!readonly"
      class="text-center"
    >
      <q-btn
        fab-mini
        icon="fa fa-plus"
        color="positive"
        @click="onEditCommentaire()"
      />
    </div>
    <q-timeline
      v-if="value.length"
      :side="side"
    >
      <transition-group
        appear
        enter-active-class="animated slideInRight"
        leave-active-class="animated slideOutRight"
      >
        <!--        :side="layout !== 'dense' ? i % 2 ? 'right' : 'left' : 'right'"-->
        <time-line-events-message
          v-for="message in value"
          :key="message.id"
          :message="message"
          :readonly="readonly"
          @delete="onDeleteCommentaire(message)"
          @edit="onEditCommentaire(message)"
        />
      </transition-group>
    </q-timeline>
    <dialog-event-message
      v-model="showEdit"
      :constatation="constatation"
      @submit="onSubmitConstatation"
    />
  </div>
</template>
<script>
import autoDefaultModelMixin from '@/mixins/autoDefaultModelMixin'
import { dialogConfirm } from '@/utils/ui'
import { getLocation } from '@/utils/io/geolocation'
import TimeLineEventsMessage from 'components/TimeLineEventsMessage'
import DialogEventMessage from 'components/Dialog/DialogEventMessage'

export default {
  name: 'TimeLineEvents',
  components: { DialogEventMessage, TimeLineEventsMessage },
  mixins: [autoDefaultModelMixin],
  props: {
    value: {
      type: Array,
      default: _.stubArray
    },
    title: {
      type: String,
      default: 'Constatations'
    },
    side: {
      type: String,
      default: undefined
    },
    readonly: Boolean
  },
  data () {
    return {
      showEdit: false,
      constatation: {}
    }
  },
  computed: {
    layout () {
      return this.$q.screen.lt.sm
        ? 'dense'
        : 'loose'
    }
  },
  methods: {
    onDeleteCommentaire (constat) {
      const value = [...this.value]
      const i = _.findIndex(value, { id: constat.id })
      if (i !== -1) {
        dialogConfirm('Supprimer cet élément ?')
          .onOk(() => {
            value.splice(i, 1)
            this.$emit('submit', value)
          })
      }
    },
    onEditCommentaire (constat = {}) {
      this.constatation = _.cloneDeep(constat)
      this.showEdit = true
    },
    async onSubmitConstatation () {
      const value = [...this.value]
      this.constatation.location = await getLocation()
      if (this.constatation.id) {
        const i = _.findIndex(value, { id: this.constatation.id })
        value.splice(i, 1, this.constatation)
      } else {
        value.unshift(this.constatation)
      }
      this.$emit('submit', value)
      this.showEdit = false
    }
  }
}
</script>
